// extracted by mini-css-extract-plugin
export default {"container":"GameMenu_container__BQFvz"};